import React, { Component } from 'react';
import { Drawer, Button } from '@blueprintjs/core';
import {
	DrawerHeader,
	PlainButton,
	Table,
	TableHeader,
	TableData,
	Container
} from 'components/styled-components';
import { IconNames } from '@blueprintjs/icons';
import colors from 'utils/colors';
import cloneDeep from 'lodash/cloneDeep';
import Select from 'react-select';
import {
	HeaderControls,
	ScrollWrapper,
	TableRow,
	Wrapper
} from 'containers/Manage-Questionnaire/styled-components';

class QuestionTypeReorderDrawer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			list: []
		};
	}

	componentDidUpdate(prevProps){
		if(
			(JSON.stringify(prevProps.list) !== JSON.stringify(this.props.list))
			|| (prevProps.isOpen === false && this.props.isOpen === true)
		){
			this.updateList();
		}
	}

	updateList = () => {
		const newList = cloneDeep(this.props.list)
		.map((item, itemKey) => { // cleanup the 999 ordering
			if(item.displayOrder === 999){
				item.displayOrder = itemKey + 1;
			}
			return item;
		})

		this.setState({list: newList});
	}

	handleCloseDrawer = () => {
		// handle any local 'cleanup' before we use the parent's method for closing the drawer
		this.props.closeDrawer();
	};

	handleSaveOrder = () => {
		const updatedList = cloneDeep(this.state.list);
		this.props.handleSaveOrder(updatedList);
	}

	handleChangeOrder = (value, key) => {
		const previousOrder = this.state.list[key].displayOrder;
		const newOrder = value.value;
		
		let newList = cloneDeep(this.state.list)
							.map(item => { //re-order the rest of the list
								if(newOrder < previousOrder){
									if(item.displayOrder >= newOrder && item.displayOrder < previousOrder){
										item.displayOrder = item.displayOrder + 1;
									}
								}else{
									if(item.displayOrder <= newOrder && item.displayOrder > previousOrder){
										item.displayOrder = item.displayOrder - 1;
									}
								}
								return item;
							})

		newList[key].displayOrder = value.value;
		this.setState({list: newList});
	}

	render() {
		const { isOpen } = this.props;
		const { list } = this.state;

		return (
			<Drawer isOpen={isOpen} onClose={this.handleCloseDrawer}>
				<DrawerHeader>
					Re-order Question Types
					<HeaderControls>
						<Button icon={IconNames.CROSS} onClick={this.handleCloseDrawer} minimal />
					</HeaderControls>
				</DrawerHeader>
				<ScrollWrapper>
					<Container background={colors.whiteGray} width="95%">
						<Wrapper>
							<Table>
								<tbody>
									<TableRow>
										<TableHeader>Question Type</TableHeader>
										<TableHeader>Order</TableHeader>
									</TableRow>
									{list.map((psq, pskey) => {
										return (
											<TableRow key={`prscreen-reorder-${pskey}`}>
												<TableData>{psq.typeName}</TableData>
												<TableData>
													<Select
														onChange={(thing) => this.handleChangeOrder(thing, pskey)}
														value={{ label: psq.displayOrder, value: psq.displayOrder }}
														options={list.map((v,k) => {
															return { label: k+1, value: k+1 };
														})}
													/>
												</TableData>
											</TableRow>
										)
									})}
								</tbody>
							</Table>
						</Wrapper>
					</Container>
					<PlainButton style={{marginLeft: "0", display: "block", marginBottom: "1rem"}} onClick={this.handleSaveOrder}>Save Order</PlainButton>
				</ScrollWrapper>
			</Drawer>
		);
	}
}

export default QuestionTypeReorderDrawer;